import { useState, useEffect } from 'react';
import { apiService } from '@/services/api';
import { LOCAL_STORAGE_KEYS } from '@/utils/constants';

export interface UseAuthReturn {
    authToken: string | null;
    isAuthenticated: boolean;
    setAuthToken: (token: string) => void;
    logout: () => void;
    loading: boolean;
}

export const useAuth = (): UseAuthReturn => {
    const [authToken, setAuthTokenState] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Check localStorage first
        const storedToken = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
        const urlParams = new URLSearchParams(window.location.search);
        if (storedToken && (urlParams.get('auth_token') && storedToken === urlParams.get('auth_token'))) {
            setAuthTokenState(storedToken);
            setLoading(false);
            return;
        }

        // Then check URL params
        const urlToken = urlParams.get('auth_token');
        if (urlToken) {
            setAuthTokenState(urlToken);
            apiService.setAuthToken(urlToken);
            // Clean up URL without refreshing
            const newUrl = window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);
        }

        setLoading(false);
    }, []);

    const setAuthToken = (token: string) => {
        setAuthTokenState(token);
        apiService.setAuthToken(token);
    };

    const logout = () => {
        setAuthTokenState(null);
        apiService.clearAuthToken();
        localStorage.removeItem(LOCAL_STORAGE_KEYS.LAST_SECTION);
        // Optionally redirect to login or refresh
        window.location.reload();
    };

    const isAuthenticated = !!authToken;

    return {
        authToken,
        isAuthenticated,
        setAuthToken,
        logout,
        loading,
    };
};
